(function () {
  function initAnnouncementCarousel() {
    const bar = document.querySelector('.announcement-bar');
    if (!bar) return;

    const slides = [...bar.querySelectorAll('.announcement-bar__slide')];
    if (slides.length <= 1) return; // nada que rotar

    if (!slides.some((slide) => slide.classList.contains('is-active'))) {
      slides[0].classList.add('is-active');
    }

    let index = Math.max(
      slides.findIndex((slide) => slide.classList.contains('is-active')),
      0,
    );

    const seconds = Math.max(parseFloat(bar.dataset.rotateSeconds) || 5, 3);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let timer = null;
    let paused = false;

    function goTo(nextIndex) {
      slides[index].classList.remove('is-active');
      index = nextIndex;
      slides[index].classList.add('is-active');
    }

    function tick() {
      if (paused || document.hidden) return;
      goTo((index + 1) % slides.length);
    }

    function start() {
      stop();
      timer = window.setInterval(tick, seconds * 1000);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    bar.addEventListener('mouseenter', () => { paused = true; });
    bar.addEventListener('mouseleave', () => { paused = false; });
    bar.addEventListener('focusin', () => { paused = true; });
    bar.addEventListener('focusout', () => { paused = false; });

    // Swipe manual — mismo patrón de drag que el lightbox de fotos del PDP
    // (pointerdown/move/up, umbral de 60px). No hace falta esperar a que
    // rote solo: deslizar a la izquierda avanza, a la derecha retrocede.
    // Reinicia el timer del auto-rotado después de cada swipe.
    const track = bar.querySelector('.announcement-bar__track');
    let dragStartX = 0;
    let dragging = false;
    let didSwipe = false; // evita que el click del <a> navegue después de arrastrar

    track?.addEventListener('pointerdown', (e) => {
      dragging = true;
      dragStartX = e.clientX;
    });

    track?.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      e.preventDefault();
    });

    function endSwipe(e) {
      if (!dragging) return;
      dragging = false;
      const delta = e.clientX - dragStartX;
      if (delta < -40) {
        didSwipe = true;
        goTo((index + 1) % slides.length);
        if (!reduceMotion.matches) start();
      } else if (delta > 40) {
        didSwipe = true;
        goTo((index - 1 + slides.length) % slides.length);
        if (!reduceMotion.matches) start();
      }
    }

    track?.addEventListener('pointerup', endSwipe);
    track?.addEventListener('pointerleave', () => { dragging = false; });
    track?.addEventListener(
      'click',
      (e) => {
        if (!didSwipe) return;
        e.preventDefault();
        didSwipe = false;
      },
      true,
    );

    // Con prefers-reduced-motion se queda fijo en el primer mensaje activo,
    // sin auto-rotar (el swipe manual sigue funcionando igual).
    if (!reduceMotion.matches) start();
  }

  document.addEventListener('DOMContentLoaded', initAnnouncementCarousel);
})();
